<script>
  import * as restfulService from '../../../services/restfulService'
  import dataService from '../../../services/dataService'
  import * as cepService from '../../../services/cepService'
  import * as MESSAGES from '../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapActions} from 'vuex'

  import {cloneDeep} from 'lodash'
  import {required, email} from 'vuelidate/lib/validators'
  import swal from 'sweetalert2'

  export default {
    mixins: [helpers],
    data () {
      return {
        buscandoCidades: false,
        buscarCidade: null,
        botaoClicado: false,
        hashValido: false,
        mostrarDatepickerDataNascimento: false,
        data: {
          fl_cobranca: true,
          nome: '',
          cpf_cnpj: '',
          rg: '',
          data_nascimento: '',
          data_nascimento_formatada: '',
          sexo: '',
          email: '',
          telefone: '',
          cep: '',
          rua: '',
          numero: '',
          bairro: '',
          complemento: '',
          ref_estado: '',
          ref_cidade: '',
          dependentes: [],
          mes_pagamento: '01',
          fl_matricula_automatica: true
        },
        dependencias: {
          estados: [],
          cidades: [],
          sexos: [
            {
              sigla: 'M',
              nome: 'Masculino'
            },
            {
              sigla: 'F',
              nome: 'Feminino'
            }
          ],
          meses: [
            {
              mes: '01',
              nome: 'Janeiro (12x)'
            },
            {
              mes: '02',
              nome: 'Fevereiro (11x)'
            },
            {
              mes: '03',
              nome: 'Março (10x)'
            }
          ]
        }
      }
    },
    validations: {
      data: {
        nome: {required},
        cpf_cnpj: {required},
        rg: {required},
        data_nascimento: {required},
        sexo: {required},
        email: {required, email},
        telefone: {required},
        cep: {required},
        rua: {required},
        numero: {required},
        bairro: {required},
        ref_estado: {required},
        ref_cidade: {required},
        mes_pagamento: {required}
      }
    },
    computed: {
      nomeErros () {
        const erros = []
        if (!this.$v.data.nome.$dirty) return erros
        !this.$v.data.nome.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      cpfErros () {
        const erros = []
        if (!this.$v.data.cpf_cnpj.$dirty) return erros
        !this.$v.data.cpf_cnpj.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      rgErros () {
        const erros = []
        if (!this.$v.data.rg.$dirty) return erros
        !this.$v.data.rg.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      dataNascimentoErros () {
        const erros = []
        if (!this.$v.data.data_nascimento.$dirty) return erros
        !this.$v.data.data_nascimento.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      sexoErros () {
        const erros = []
        if (!this.$v.data.sexo.$dirty) return erros
        !this.$v.data.sexo.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      emailErros () {
        const erros = []
        if (!this.$v.data.email.$dirty) return erros
        !this.$v.data.email.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        !this.$v.data.email.email && erros.push(MESSAGES.VALIDATION_EMAIL)
        return erros
      },
      telefoneErros () {
        const erros = []
        if (!this.$v.data.telefone.$dirty) return erros
        !this.$v.data.telefone.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      cepErros () {
        const erros = []
        if (!this.$v.data.cep.$dirty) return erros
        !this.$v.data.cep.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      ruaErros () {
        const erros = []
        if (!this.$v.data.rua.$dirty) return erros
        !this.$v.data.rua.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      numeroErros () {
        const erros = []
        if (!this.$v.data.numero.$dirty) return erros
        !this.$v.data.numero.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      bairroErros () {
        const erros = []
        if (!this.$v.data.bairro.$dirty) return erros
        !this.$v.data.bairro.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      refEstadoErros () {
        const erros = []
        if (!this.$v.data.ref_estado.$dirty) return erros
        !this.$v.data.ref_estado.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      refCidadeErros () {
        const erros = []
        if (!this.$v.data.ref_cidade.$dirty) return erros
        !this.$v.data.ref_cidade.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      mesPagamentoErros () {
        const erros = []
        if (!this.$v.data.mes_pagamento.$dirty) return erros
        !this.$v.data.mes_pagamento.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      }
    },
    async mounted () {
      const hash = this.$route.params.hash
      if (!hash) {
        swal({
          title: 'Atenção',
          html: 'Chave de validação não encontrada',
          type: 'warning'
        })
      } else {
        const hashValido = await this.validarHash(hash)
        if (!hashValido.pessoa) {
          swal({
            title: 'Atenção',
            html: 'Chave de validação não encontrada',
            type: 'warning'
          })
        } else {
          this.hashValido = true
          this.data = {...this.data, ...hashValido.pessoa}
          await this.getDependencies()
        }
      }
      bus.$emit('hide-loader')
    },
    watch: {
      'data.data_nascimento' () {
        this.data.data_nascimento_formatada = this.dateFormat(this.data.data_nascimento, 'br')
      },
      buscarCidade: function (query) {
        if (!this.data.ref_cidade) {
          this.buscarCidades(query)
        }
      },
      'data.cep': async function (value) {
        if (value.length === 9) {
          const cep = this.onlyNumbers(value)
          const result = await cepService.get(cep)
          this.data.rua = result.logradouro
          this.data.bairro = result.bairro
          this.data.ref_estado = result.uf
          await this.buscarCidades(result.localidade)
          this.data.ref_cidade = this.dependencias.cidades[0].id
          this.$refs.dataNumero.focus()
        }
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      getDependencies () {
        return new Promise(resolve => {
          dataService.get([
            {domain: 'estado'}
          ]).then((result) => {
            this.dependencias = {...this.dependencias, ...result}
            resolve()
          })
        })
      },
      validarHash (hash) {
        return new Promise((resolve, reject) => {
          restfulService.get('pessoa', 'checar-hash', hash)
            .then(response => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)
              reject()
            })
        })
      },
      buscarCidades (query) {
        return new Promise((resolve, reject) => {
          if (query !== null && query !== '') {
            if (query !== null && query !== '') {
              this.dependencias.cidades.splice(0)
              this.buscandoCidades = true
              let data = {
                nome: {ilike: '%' + query + '%'},
                ref_estado: this.data.ref_estado
              }
              restfulService.search('cidade', null, data, null, ['estado'])
                .then((response) => {
                  this.dependencias.cidades.splice(0)
                  this.dependencias.cidades = [...this.dependencias.cidades, ...response.data]
                  this.buscandoCidades = false
                  resolve()
                })
                .catch(e => {
                  console.log(e)
                  this.buscandoCidades = false
                  reject()
                })
            } else {
              resolve()
            }
          } else {
            resolve()
          }
        })
      },
      salvarDados () {
        bus.$emit('show-loader')
        this.botaoClicado = true
        const hash = this.$route.params.hash
        let data = cloneDeep(this.data)
        if (data.cpf_cnpj) {
          data.cpf_cnpj = this.onlyNumbers(data.cpf_cnpj)
        }
        if (data.cep) {
          data.cep = this.onlyNumbers(data.cep)
        }
        if (data.telefone) {
          data.telefone = this.onlyNumbers(data.telefone)
        }
        data.dt_inicial = ['2019' + data.mes_pagamento + '05'].join('-')
        delete data.data_nascimento_formatada
        restfulService.post('pessoa', 'atualizacao-dados', hash, data)
          .then(() => {
            this.showNotification({
              message: 'Seus dados foram atualizados'
            })
            this.$v.data.$reset()
            this.botaoClicado = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-layout row wrap fluid fill-height>
        <v-flex sm6 xs12>
            <v-container>
                <h1 class="text-xs-center headline font-weight-regular">
                    Atualização de Dados Cadastrais
                </h1>
                <v-form color="vestibular-primary">
                    <v-container fluid grid-list-md>
                        <h2 class="title pb-1">Dados Pessoais</h2>
                        <v-divider class="mb-2"></v-divider>
                        <v-layout row wrap>
                            <v-flex sm12 xs12>
                                <v-text-field v-model="data.nome"
                                              label="Nome Completo"
                                              :error-messages="nomeErros"
                                              @input="$v.data.nome.$touch()"
                                              @blur="$v.data.nome.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              required/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.email"
                                              label="E-mail"
                                              :error-messages="emailErros"
                                              @input="$v.data.email.$touch()"
                                              @blur="$v.data.email.$touch()"
                                              color="amber darken-3"
                                              outline
                                              disabled
                                              box
                                              required/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.telefone"
                                              label="Telefone"
                                              v-mask="'(##) #####.####'"
                                              :error-messages="telefoneErros"
                                              @input="$v.data.telefone.$touch()"
                                              @blur="$v.data.telefone.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              required/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-select v-model="data.sexo"
                                          :items="dependencias.sexos"
                                          label="Sexo"
                                          :error-messages="sexoErros"
                                          @input="$v.data.sexo.$touch()"
                                          @blur="$v.data.sexo.$touch()"
                                          item-value="sigla"
                                          item-text="nome"
                                          color="amber darken-3"
                                          outline
                                          box
                                          required>
                                </v-select>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-menu ref="datepickerDataNascimento"
                                        :close-on-content-click="false"
                                        v-model="mostrarDatepickerDataNascimento"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px">
                                    <v-text-field slot="activator"
                                                  v-model="data.data_nascimento_formatada"
                                                  v-mask="'##/##/####'"
                                                  label="Data de Nascimento"
                                                  persistent-hint
                                                  required
                                                  color="amber darken-3"
                                                  outline
                                                  box
                                                  @blur="data.data_nascimento = dateFormat(data.data_nascimento_formatada, 'en')"/>
                                    <v-date-picker v-model="data.data_nascimento"
                                                   @input="mostrarDatepickerDataNascimento = false"
                                                   locale="pt-br"/>
                                </v-menu>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.cpf_cnpj"
                                              label="CPF"
                                              v-mask="'###.###.###-##'"
                                              :error-messages="cpfErros"
                                              @input="$v.data.cpf_cnpj.$touch()"
                                              @blur="$v.data.cpf_cnpj.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              required/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.rg"
                                              label="RG"
                                              :error-messages="rgErros"
                                              @input="$v.data.rg.$touch()"
                                              @blur="$v.data.rg.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              required/>
                            </v-flex>
                        </v-layout>
                        <h2 class="title pb-1">Endereço</h2>
                        <v-divider class="mb-2"></v-divider>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.cep"
                                              label="CEP"
                                              v-mask="'#####-###'"
                                              :error-messages="cepErros"
                                              @input="$v.data.cep.$touch()"
                                              @blur="$v.data.cep.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              required/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.rua"
                                              :error-messages="ruaErros"
                                              @input="$v.data.rua.$touch()"
                                              @blur="$v.data.rua.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              label="Rua"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.numero"
                                              :error-messages="numeroErros"
                                              @input="$v.data.numero.$touch()"
                                              @blur="$v.data.numero.$touch()"
                                              color="amber darken-3"
                                              ref="dataNumero"
                                              outline
                                              box
                                              label="Número"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="data.bairro"
                                              :error-messages="bairroErros"
                                              @input="$v.data.bairro.$touch()"
                                              @blur="$v.data.bairro.$touch()"
                                              color="amber darken-3"
                                              outline
                                              box
                                              label="Bairro"/>
                            </v-flex>
                            <v-flex sm12 xs12>
                                <v-text-field v-model="data.complemento"
                                              color="amber darken-3"
                                              outline
                                              box
                                              label="Complemento"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-select v-model="data.ref_estado"
                                          :error-messages="refEstadoErros"
                                          @input="$v.data.ref_estado.$touch()"
                                          @blur="$v.data.ref_estado.$touch()"
                                          :items="dependencias.estados"
                                          item-text="nome"
                                          item-value="id"
                                          label="Estado"
                                          placeholder="Selecione o estado"
                                          no-data-text="Nenhuma registro encontrado"
                                          color="amber darken-3"
                                          outline
                                          box
                                          hide-no-data
                                          hide-selected
                                          clearable></v-select>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-autocomplete v-model="data.ref_cidade"
                                                :error-messages="refCidadeErros"
                                                @input="$v.data.ref_cidade.$touch()"
                                                @blur="$v.data.ref_cidade.$touch()"
                                                :disabled="!data.ref_estado"
                                                :items="dependencias.cidades"
                                                :loading="buscandoCidades"
                                                :search-input.sync="buscarCidade"
                                                item-text="nome"
                                                item-value="id"
                                                label="Cidade"
                                                placeholder="Digite o nome da cidade"
                                                no-data-text="Nenhuma registro encontrado"
                                                color="amber darken-3"
                                                outline
                                                box
                                                hide-no-data
                                                hide-selected
                                                clearable></v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <h2 class="title pb-1">Dependentes</h2>
                        <v-divider class="mb-1"></v-divider>
                        <v-list two-line class="mb-4">
                            <template v-for="(item, index) in data.dependentes">
                                <v-list-tile :key="item.title" class="elevation-1">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{item.ref_pessoa}}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{item.nome}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                        <h2 class="title pb-1">Financeiro</h2>
                        <v-divider class="mb-1"></v-divider>
                        <v-layout row wrap class="mb-4">
                            <v-flex sm6 xs12>
                                <v-checkbox v-model="data.fl_matricula_automatica"
                                            label="Autorizo a rematrícula automática"
                                            color="amber darken-3"
                                            type="checkbox"></v-checkbox>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-select v-model="data.mes_pagamento"
                                          :items="dependencias.meses"
                                          label="Mês do 1º Pagamento"
                                          :error-messages="mesPagamentoErros"
                                          @input="$v.data.mes_pagamento.$touch()"
                                          @blur="$v.data.mes_pagamento.$touch()"
                                          item-value="mes"
                                          item-text="nome"
                                          color="amber darken-3"
                                          outline
                                          box
                                          required>
                                </v-select>
                            </v-flex>
                        </v-layout>
                        <v-btn color="success"
                               @click="salvarDados()"
                               class="btn"
                               block
                               large
                               :disabled="botaoClicado || $v.data.$invalid || !hashValido">
                            <i class="fas fa-check"></i>
                            <span class="pl-2">Salvar Dados</span>
                        </v-btn>
                    </v-container>
                </v-form>
            </v-container>
        </v-flex>
        <v-flex sm6 xs12 class="box-dados-cadastrais">
            <div class="flex-logo">
                <div>
                    <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
                </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<style lang="scss">
    .box-dados-cadastrais {
        background: linear-gradient(180deg, #3b5047 85%, #283630 0%);
        border-top: 4px solid #909e48;
        .flex-logo {
            display: flex;
            min-height: 100vh;
            justify-content: center;
            align-items: center;
            padding: 20px 0;
            img {
                max-width: 350px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// AtualizacaoDados.vue?6f6958f1